export const LocalDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const LocalDateFormat = 'YYYY-MM-DD';
